export const BINDING_RESTRICTIONS_RESPONSE = "BINDING_RESTRICTIONS_RESPONSE";

export type BindingRestrictionsData = {
    isEligible: boolean;
};

export type BindingRestrictionsResponse = {
    type: typeof BINDING_RESTRICTIONS_RESPONSE;
    data: BindingRestrictionsData;
};
